<template>
    <div v-if="podcast"
         class="podcast-card"
         :class="[
             podcast.type,
             featured ? 'featured' : '',
             is_locked ? 'locked' : ''
         ]"
         :style="`background-image: url(${featured ? image_medium : image_small });`">
        <div class="inner">

            <div class="lock">
                <img src="/images/icons/lock.svg" alt="">
                Only available with a School Subscription
            </div>

            <div class="special" v-if="featured">
                <div class="line"><i class="fas fa-star"></i> Featured</div>
            </div>
            <div class="specs">
                <div class="line">
                    <icon-clock class="icon"/> {{ podcast.duration }}
                </div>
                <div class="line">
                    <icon-check class="icon"/> {{ podcast.difficulty }}
                </div>
                <div class="line" v-if="is_video">
                    <icon-video class="icon"/> Video Podcast
                </div>
            </div>
            <div class="actions">
                <a v-if="!is_locked"
                   :href="podcast_url"
                   class="btn btn-light d-flex align-items-center mb-2 mx-2">
                    <svg xmlns="http://www.w3.org/2000/svg" width="22.982" height="22.982" viewBox="0 0 22.982 22.982"><path d="M5.3,7.6H3V23.684a2.3,2.3,0,0,0,2.3,2.3H21.386v-2.3H5.3ZM23.684,3H9.895A2.3,2.3,0,0,0,7.6,5.3V19.088a2.3,2.3,0,0,0,2.3,2.3H23.684a2.3,2.3,0,0,0,2.3-2.3V5.3A2.3,2.3,0,0,0,23.684,3ZM14.491,17.364V7.022l6.895,5.171Z" transform="translate(-3 -3)"></path></svg>
                    <span class="ml-2">Play Podcast</span>
                </a>
                <inertia-link v-if="showCreate"
                              :href="create_project_url"
                              class="btn btn-success d-flex align-items-center mb-2 mx-2">
                    <span class="ml-2">Start project with this episode</span>
                </inertia-link>

                <template v-if="!is_locked && actions">
                    <button v-for="(action, idx) in actions" :key="idx" @click.prevent.stop="action.action(podcast)"
                            class="btn d-flex align-items-center mb-2 mx-2" :class="action.class">
                        <span v-html="action.title"></span>
                    </button>
                </template>
            </div>
            <div class="caption">
                <div class="icon">
                    <svg v-if="is_video" xmlns="http://www.w3.org/2000/svg" width="22.982" height="22.982" viewBox="0 0 22.982 22.982" class="ico"><path d="M5.3,7.6H3V23.684a2.3,2.3,0,0,0,2.3,2.3H21.386v-2.3H5.3ZM23.684,3H9.895A2.3,2.3,0,0,0,7.6,5.3V19.088a2.3,2.3,0,0,0,2.3,2.3H23.684a2.3,2.3,0,0,0,2.3-2.3V5.3A2.3,2.3,0,0,0,23.684,3ZM14.491,17.364V7.022l6.895,5.171Z" transform="translate(-3 -3)"></path></svg>
                    <svg v-else xmlns="http://www.w3.org/2000/svg" width="24" height="26.667" viewBox="0 0 24 26.667" class="ico"><defs></defs><path d="M11.76,26.475h2.667v-16H11.76Zm5.333,5.333H19.76V5.141H17.093V31.808ZM6.427,21.141H9.093V15.808H6.427Zm16,5.333h2.667v-16H22.427ZM27.76,15.808v5.333h2.667V15.808Z" transform="translate(-6.427 -5.141)"></path></svg>
                </div>
                <h6>{{ podcast.name }}</h6>
                <p class="mb-0">{{ podcast.description }}</p>

                <div class="tags" v-if="showGroups">
                    <div class="tag" v-for="s in groups" :key="s.id">
                        <span class="tag-type">{{s.type}}:</span>
                        <span class="tag-name">{{s.name}}</span>
                    </div>
                </div>

            </div>
        </div>

<!--        <modal v-if="preview"-->
<!--               :id="utils.randomId({prefix: 'modal'})"-->
<!--               :show="preview"-->
<!--               size="xl"-->
<!--               @close="closePreviewModal()">-->
<!--            <template #title>{{ podcast.name }}</template>-->
<!--            <iframe :src="route('embed.podcast', {slug, start: showStart, download: showDownload})"-->
<!--                    ref="modal"-->
<!--                    @resize="fixHeight()"-->
<!--                    @load="fixHeight()"-->
<!--                    frameborder="0"></iframe>-->
<!--        </modal>-->

    </div>

</template>

<script>
import utils from "@/mixins/utils";
import uploads from "@/mixins/uploads";
import IconClock from "@/Icons/IconClock";
import IconCheck from "@/Icons/IconCheck";
import Modal from "@/Components/Common/Modal";
import PodcastPlayer from "@/Components/Podcast/PodcastPlayer";
import IconVideo from "@/Icons/IconVideo";

export default {
    name: "PodcastCard",
    components: {IconVideo, PodcastPlayer, Modal, IconCheck, IconClock},
    mixins: [utils, uploads],

    props: {
        podcast: {
            type: Object,
        },
        featured: {
            type: Boolean,
            default: false,
        },
        openInModal: {
            type: Boolean,
            default: false,
        },
        actions: {
            type: [Array, Object],
            default: null,
        },
        showStart: {
            type: Boolean,
            default: true,
        },
        showDownload: {
            type: Boolean,
            default: true,
        },
        showGroups: {
            type: Boolean,
            default: true,
        },
        headless: {
            type: Boolean,
            default: false,
        }
    },

    data(){
        return {
            preview: false,
        };
    },

    computed: {

        is_locked(){

            if( this.is_admin ) return false;

            const types = ['open'];
            if( this.is_student || this.is_teacher ) {
                types.push('free');
            }

            if( this.currentUserAccountTypeIs('paid') ){
                types.push('paid');
            }

            console.log({types, groups: this.groups});

            return this.groups.findIndex((g) => g.type === 'pay' && types.includes( g.name )) < 0;
        },

        is_video(){
            return this.podcast?.type === 'video';
        },

        slug(){
            return this.podcast?.short_name;
        },

        image_small(){
            return this.uploads.image( this.podcast.picture_large, {w: 480, h: 480, c:true});
        },

        image_medium(){
            return this.uploads.image( this.podcast.picture_large, {w: 800, h: 800, c: true});
        },

        public_podcast_preview_url(){
            return this.route('podcast.show', {slug: this.podcast.short_name, headless: this.headless ? 'yes' : '', ...this.global_url_params})
        },

        admin_podcast_preview_url(){
            return this.route('pc.show', {podcast: this.podcast.id, headless: this.headless ? 'yes' : '', ...this.global_url_params});
        },

        podcast_url(){
            if( this.$page.props?.isBackend ) return this.admin_podcast_preview_url;
            return this.public_podcast_preview_url;
        },

        groups(){
            return this.podcast.groups ?? [];
        },

        create_project_url(){
            return this.route('project.create', {
                path: process.env.MIX_DEFAULT_LEARNING_PATH, // Should give a place for editing config.
                podcast: this.slug,
               ...this.global_url_params,
           });
        },

    },

    methods: {
        // showPreviewModal(){
        //     if( this.openInModal ){
        //         this.preview = true;
        //     }else{
        //         this.$inertia.visit(this.url);
        //         // window.open(this.url, '_self').focus();
        //     }
        // },
        //
        // closePreviewModal(){
        //     this.preview = false;
        // },
        //
        // fixHeight(){
        //     this.$refs.modal.height = "";
        //     this.$refs.modal.height = this.$refs.modal.contentWindow.document.body.scrollHeight + "px";
        // }
    },

    mounted() {
        // console.log({groups: this.groups});
    }

}
</script>

<style lang="scss" scoped>
.podcast-card{
    background: transparent no-repeat 50%/cover;
    border-radius: 19px;
    border: 6px solid #fff;
    box-shadow: 0 3px 8px rgb(0 0 0 / 16%);
    position: relative;
    height: 480px;
    // margin-left: 1rem;

    &:hover{
        .inner{
            background: rgba($primary, .9);
        }

        .actions{
            opacity: 1;
        }
    }

    &.video{
        .caption{
            .icon{
                background: $secondary;
            }
        }
    }


    &.featured{
        .special{
            left: auto;
            right: -16px;
        }
        .specs{
            left: -16px;
            right: auto;
        }
    }


    &.locked{
        cursor: not-allowed;

        .lock{
            display: flex;
        }
        .caption{
            opacity: .7;
        }
    }
}

.lock{
    display: none;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 0;
    background: rgba(white, .7);
    border-radius: .8rem;
    align-items: center;
    justify-content: center;

    img{
        width: 5rem;
        height: auto;
    }
}

.inner{
    position: absolute;
    top: -6px;
    right: -6px;
    bottom: -6px;
    left: -6px;
    border-radius: 18px;
    border: 6px solid transparent;
    transition: background .3s,border .3s;

    .line{
        display: flex;
        align-items: center;
    }
}

.special{
    position: absolute;
    top: 16px;
    left: -16px;
    right: auto;
    background: $warning;
    padding: 10px;
    border-radius: 9px;
    color: black;
    font-size: 14px;
    text-transform: uppercase;
    font-weight: 700;
    box-shadow: 0 3px 6px rgb(0 0 0 / 16%);
}

.specs{
    position: absolute;
    top: 16px;
    left: auto;
    right: -16px;
    background: #23252c;
    padding: 10px;
    border-radius: 9px;
    color: #fff;
    font-size: 14px;
    text-transform: uppercase;
    font-weight: 700;
    box-shadow: 0 3px 6px rgb(0 0 0 / 16%);

    .icon{
        margin-right: .4rem;
        width: 16px;
        height: auto;
    }
}

.actions{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    margin-top: -30px;
    opacity: 0;
    transition: opacity .3s;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
}

.caption{
    position: absolute;
    right: -5px;
    bottom: -5px;
    left: -5px;
    padding: 16px 16px 16px 26px;
    background: hsla(0,0%,100%,.9);
    border-radius: 0 0 17px 17px;
    font-size: .9rem;

    .icon{
        background: $primary;
        color: #fff;
        width: 36px;
        height: 36px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        left: -2px;
        top: 14px;
        transform: translate(-50%);

        .ico{
            width: 18px;
            height: auto;
            fill: white;
        }
    }

    h6{
        font-size: 23px;
    }

    .special{

    }
}

iframe{
    width: 100%;
}

.tags{
    margin-top: .6rem;

    .tag{
        display: inline-block;
        margin-right: .3rem;
        padding: .1rem .3rem;
        background: rgba(black, .1);
        border-radius: .3rem;
        cursor: default;

        .tag-type{
            color: lighten(black, 35%);
        }

        &:hover{
            .tag-type{
                color: black;
            }
            .tag-name{
                color: $feel;
            }
        }
    }
}

</style>
